module.exports = __webpack_public_path__ + "statics/img/Marketing-2.1ab17132.png";